import React from "react";
import { CollectionsGroup } from "./CollectionsGroup";
import { Product } from "../../../../core/types/entities";
import { useTranslation } from "react-i18next";

type CollectionsProps = {
  collections: Product[][];
};

const Collections = ({ collections }: CollectionsProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2.5">
      <span className="text-sm font-semibold">{t("Collections")}</span>
      <div className="flex gap-1.5">
        {collections?.[0].map((collection, i) => <CollectionsGroup key={collection.id} collection={collection} />)}
      </div>
    </div>
  );
};

export default Collections;
